import React, { Component } from 'react'
import AWSAPI from '../../../common/AWSAPI'
import Loading from '../../../common/component/Loading'
import ReactStringReplace from 'react-string-replace'

class InformationList extends Component {
  constructor (props) {
    super(props)
    this.state = {isLoaded: false, targetYear: '', informationYearList: []}
  }
  componentWillMount () {
    this.loadInformationList()
  }
  loadInformationList () {
    const onSuccess = (res) => {
      const informationList = res.body.data.systemSettingValue
      const years = []
      informationList.forEach((info) => {
        if (!years.includes(info.year)) years.push(info.year)
      })
      this.setState({
        isLoaded: true,
        informationList: informationList,
        informationYearList: years
      })
    }
    const params = {
      command: 'get',
      systemSettingName: 'InformationSetting'
    }
    AWSAPI.apiPost(this.userRole, this.apiUrl, params, onSuccess)
  }
  selected (information, e) {
    this.props.history.push('/' + this.userRoleUrl + '/information/detail/' + information.id)
  }
  selectYear (year) {
    this.setState({
      targetYear: year
    })
  }
  renderInformationYearList (state) {
    return state.informationYearList.map((informationYear) => {
      return (<li key={informationYear} className={state.targetYear === informationYear ? 'active' : ''}>
        <a data-category='1' onClick={(e) => this.selectYear(informationYear)}><i className='icon-chevron-right pull-right' />{informationYear}</a>
      </li>)
    })
  }
  renderInformationYearBox (state) {
    let informationYearList = state.informationYearList
    if (state.targetYear) {
      informationYearList = [state.targetYear]
    }
    return informationYearList
        .map((informationYear) => {
          const informationList = state.informationList.filter((e) => e.year === informationYear)
          const informationListToShow = informationList.map((info) => {
            return (
              <tr key={info.id} onClick={(information, e) => this.selected(info, e)}>
                <td>{info.year}/{this.zeroPack(info.month)}/{this.zeroPack(info.day)} {this.zeroPack(info.hour)}:{this.zeroPack(info.minutes)}</td>
                <td>{this.convHttpLink(this.nl2br(info.body))}</td>
              </tr>
            )
          })
          return (
            <div key={informationYear} className='box'>
              <div className='box-header'>
                <i className='icon-info-sign icon-large' />
                <h5>{informationYear}年</h5>
              </div>
              <div className='box-content box-table'>
                <table className='table table-hover tablesorter'>
                  <thead>
                    <tr>
                      <th className='kw-list-date'>日時</th>
                      <th>内容</th>
                    </tr>
                  </thead>
                  <tbody>
                    {informationListToShow}
                  </tbody>
                </table>
              </div>
            </div>
          )
        })
  }
  nl2br (text) {
    if (!(typeof (text) === 'string' || text instanceof String)) return
    const regex = /(\n)/g
    return text.split(regex).map(function (line, index) {
      if (line.match(regex)) {
        return React.createElement('br', { key: index })
      } else {
        return line
      }
    })
  }
  zeroPack (text) {
    return ('0' + text).slice(-2)
  }
  convHttpLink (text) {
    const regExp = /(https?:\/\/\S+)/g
    return ReactStringReplace(text, regExp, (match, i) => (
      <a key={text} href={match} target='_blank'>{match}</a>
    ))
  }
  render () {
    if (!this.state.isLoaded) {
      return <Loading />
    }
    const informationYearSelector = this.renderInformationYearList(this.state)
    const informationYearBox = this.renderInformationYearBox(this.state)
    const pageNavi = this.renderPageNavi()
    return (
      <div>
        {pageNavi}
        <section className='page container'>
          <div className='row'>
            <div className='span4'>
              <div className='blockoff-right'>
                <ul className='nav nav-list' id='person-list'>
                  <li className='nav-header'>公開年月</li>
                  <li className={this.state.targetYear === '' ? 'active' : ''} onClick={(e) => this.selectYear('')}>
                    <a id='view-all'>
                      <i className='icon-chevron-right pull-right' />
                      <b>全ての年を表示</b>
                    </a>
                  </li>
                  {informationYearSelector}
                </ul>
              </div>
            </div>
            <div className='span12'>
              {informationYearBox}
            </div>
          </div>
        </section>
      </div>
    )
  }
}

export default InformationList



// WEBPACK FOOTER //
// ./src/common/pages/secure/InformationList.js